import { createFileRoute } from '@tanstack/react-router'
import { TestPage } from '@features/admin/test'

export const Route = createFileRoute('/admin/test')({
  component: RouteComponent,
})

function RouteComponent() {
  return <TestPage />
}
